import { BLT_API_BASE_URL } from '@/core/constants/appConfig/environment';
import { TMableEvent } from '@/core/constants/event_types/base_mable_event';
import { ScriptHandler } from '@/core/handlers/script';
import { callWgsAPI } from '@/shared/fetch_client';
import { Logger } from '@/shared/logger/logger';

import { TBLTResponse } from './types';

/**
 * Service for handling BLT (Business Logic Transaction) operations
 * @namespace BLTService
 */
const BLTService = {
  /**
   * Processes a BLT event by sending it to the API
   * @async
   * @param {TMableEvent} request - The BLT request object to process
   * @returns {Promise<TBLTResponse>} A promise that resolves with the BLT response
   * @throws {Error} If the API call fails
   */
  async processEvent(request: TMableEvent): Promise<TBLTResponse> {
    return Logger.profileFnAsync('BLTService:processEvent', async () => {
      const response = await callWgsAPI<TBLTResponse>({
        body: JSON.stringify(request),
        method: 'POST',
        params: {
          uid: ScriptHandler.getInstance().getSourceUid(),
        },
        url: `${BLT_API_BASE_URL}${BLTService.route}/events`,
      });

      return response.data;
    });
  },
  /** Base route for BLT API endpoints */
  route: '/blt',
};

export default BLTService;
